import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import AddObject from "../../../assets/ImageEditing/images/Add_object.jpg";
import Blending from "../../../assets/ImageEditing/images/Blending.jpg";
import RemoveObject from "../../../assets/ImageEditing/images/Remove_Object.jpg";
import ReplaceObject from "../../../assets/ImageEditing/images/Replace_object.jpg";
import Eraser from "../../../assets/ImageEditing/images/api-erase-elements.jpg";
import GenFill from "../../../assets/ImageEditing/images/api-genfill.jpg";
import Rewrite from "../../../assets/ImageEditing/images/rewrite.jpg";

import ModifyPresenter from "../../../assets/ImageEditing/images/api-modify-presenter.jpg";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import LinkConstants from "../../../constants/LinkConstants";
import RouterConstants from "../../../constants/RouterConstants";

const ObjectContentManipulation = () => {
	const { t } = useTranslation("translation", { keyPrefix: "imageEditing.api" });
	const navigate = useNavigate();

	const rightActions = (
		<>
			<BriaButton buttonType="secondarySmall" onClick={() => navigate(RouterConstants.ACCOUNT_IFRAMES.fullPath)}>
				{t("headerButtons.configureIframe")}
			</BriaButton>
			<BriaButton
				buttonType="secondarySmall"
				onClick={() => navigate(RouterConstants.IMAGE_EDITING.IMAGE.DEMO.fullPath)}
			>
				{t("headerButtons.playground")}
			</BriaButton>
		</>
	);

	const openDocs = (link: string) => window.open(link, "_blank");

	const objectContentManipulationCards: ConsoleAPICardProps[] = [
		{
			image: GenFill,
			header: t("cards.genFill.header"),
			description: t("cards.genFill.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.IMAGE_EDITING.GEN_FILL.DOCS)}
					>
						{t("cards.genFill.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => window.open(LinkConstants.IMAGE_EDITING.GEN_FILL.COMFY_UI.NODE, "_blank")}
					>
						{t("common.comfyNodeBtn")}
					</BriaButton>
				</>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.GEN_FILL.DOCS),
		},
		{
			image: AddObject,
			header: t("cards.addObject.header"),
			description: t("cards.addObject.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.ADD_OBJECT.DOCS)}
				>
					{t("cards.addObject.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.ADD_OBJECT.DOCS),
		},
		{
			image: ReplaceObject,
			header: t("cards.replaceObject.header"),
			description: t("cards.replaceObject.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.REPLACE_OBJECT.DOCS)}
				>
					{t("cards.replaceObject.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.REPLACE_OBJECT.DOCS),
		},
		{
			image: RemoveObject,
			header: t("cards.eraseObject.header"),
			description: t("cards.eraseObject.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.ERASE_OBJECT.DOCS)}
				>
					{t("cards.eraseObject.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.ERASE_OBJECT.DOCS),
		},
		{
			image: Blending,
			header: t("cards.imageBlending.header"),
			description: t("cards.imageBlending.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.IMAGE_BLENDING.DOCS)}
				>
					{t("cards.imageBlending.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.IMAGE_BLENDING.DOCS),
		},
		{
			image: Rewrite,
			header: t("cards.rewrite.header"),
			description: t("cards.rewrite.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.IMAGE_EDITING.REWRITE.DOCS)}>
					{t("cards.rewrite.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.REWRITE.DOCS),
		},
		{
			image: ModifyPresenter,
			header: t("cards.modifyPresenter.header"),
			description: t("cards.modifyPresenter.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.MODIFY_PRESENTER.DOCS)}
				>
					{t("cards.modifyPresenter.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.MODIFY_PRESENTER.DOCS),
		},
		{
			image: Eraser,
			header: t("cards.eraser.header"),
			description: t("cards.eraser.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.IMAGE_EDITING.ERASER.DOCS)}
					>
						{t("cards.eraser.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => window.open(LinkConstants.IMAGE_EDITING.ERASER.COMFY_UI.NODE, "_blank")}
					>
						{t("common.comfyNodeBtn")}
					</BriaButton>
				</>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.ERASER.DOCS),
		},
	];

	return (
		<ConsoleAPILayout rightActions={rightActions} showIntegrationKeyButton>
			<ConsoleAPICards cards={objectContentManipulationCards} />
		</ConsoleAPILayout>
	);
};

export default observer(ObjectContentManipulation);
